import { render, staticRenderFns } from "./address.vue?vue&type=template&id=a24e4b26&"
import script from "./address.vue?vue&type=script&lang=js&"
export * from "./address.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\jenkinsworkspace\\Aigo.B2CAdmin.Publish\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a24e4b26')) {
      api.createRecord('a24e4b26', component.options)
    } else {
      api.reload('a24e4b26', component.options)
    }
    module.hot.accept("./address.vue?vue&type=template&id=a24e4b26&", function () {
      api.rerender('a24e4b26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/userManagement/address.vue"
export default component.exports